// extracted by mini-css-extract-plugin
module.exports = {"modal":"PhysiciansModal_modal__yUIRe","icon":"PhysiciansModal_icon__1sZVp"};